import type { LucideIcon } from "lucide-react";

export type StateTone = "success" | "info" | "warning" | "danger";

const tones: Record<StateTone, string> = {
  success: "bg-success-soft text-success",
  info: "bg-accent-soft text-accent",
  warning: "bg-warning-soft text-warning",
  danger: "bg-danger-soft text-danger",
};

/** The square that heads a passage screen and says at a glance how things stand. */
export function StateIcon({ icon: Icon, tone }: { icon: LucideIcon; tone: StateTone }) {
  return (
    <span className={`grid size-12 place-items-center rounded-xl ${tones[tone]}`}>
      <Icon aria-hidden="true" className="size-6 stroke-[1.5]" />
    </span>
  );
}
